/**
 * Utility function to generate proper image URLs from asset IDs or existing URLs
 */
export const getImageUrl = (
  imageIdOrUrl: string,
  variant:
    | 'original'
    | 'inpaint'
    | 'public'
    | 'smallpreview'
    | 'replace'
    | 'iconsize'
    | 'mediumpreview'
    | 'mid' = 'mid',
  watermark: boolean = false,
): string => {
  // If it's already a data URL or regular URL, return it as is
  let img = imageIdOrUrl?.startsWith('data:image')
    ? imageIdOrUrl
    : imageIdOrUrl?.startsWith('http')
    ? imageIdOrUrl
    : undefined;

  if (img) return img;

  // Set dimensions based on variant
  let width, height;
  switch (variant) {
    case 'iconsize':
      width = height = 200;
      break;
    case 'inpaint':
      width = height = 768;
      break;
    case 'mediumpreview':
      width = height = 300;
      break;
    case 'mid':
      width = height = 512;
      break;
    case 'original':
      width = height = 600000;
      break;
    case 'public':
      width = 1366;
      height = 768;
      break;
    case 'replace':
      width = height = 1366;
      break;
    case 'smallpreview':
      width = height = 240;
      break;
    default: // Default width and height
      width = height = 512;
      break;
  }

  // Construct the new source URL with the extracted parameters
  img = `https://images.renovateai.app/ren/resize:fit:${width}:${height}:0/watermark:${
    watermark ? 1 : 0
  }:soea:0:0:0.3/plain/s3://renovate-ai/${imageIdOrUrl}`;

  return img;
};